module.exports = __webpack_public_path__ + "img/ofanoa_yes.299874cc.png";